import React from 'react';
import { Skeleton } from '@cargomatic/ui';
import { useOrderRateCards } from './hooks/useOrderRateCards';
import { handleDownloadRateCard } from 'utils/documentUtils';
export default function CarrierRateCardLink({ orderId, carrierId }) {
    var _a;
    const { data, isLoading } = useOrderRateCards(orderId, {
        carrierId,
    });
    return (React.createElement("div", { className: "mb-4 -mt-3" }, isLoading ? (React.createElement(Skeleton, { className: "h-4 w-48" })) : ((_a = data === null || data === void 0 ? void 0 : data.carrierRateCard) === null || _a === void 0 ? void 0 : _a.pdfUrl) ? (React.createElement("button", { type: "button", className: "text-sm text-blue-600 hover:underline", onClick: () => { var _a; return handleDownloadRateCard((_a = data.carrierRateCard) === null || _a === void 0 ? void 0 : _a.pdfUrl, true); } }, "Latest Carrier Rate Card")) : (React.createElement("span", { className: "text-sm text-muted-foreground" }, (data === null || data === void 0 ? void 0 : data.carrierAccountId)
        ? 'No rate card generated'
        : 'No single carrier detected'))));
}
